import React, { Component } from "react";
// import { thisExpression } from "@babel/types";
 
class Header extends Component {
    
  render() {
    let image = this.props.titleImage;
    return (
        <header className="c-main-header">
            <div className="container">
                <div className="header-content">
                    {/* <div className="h-menu">
                        <div className="nav-icon js-sideMenu">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div> */}
                    <div className="page-title">
                        <div className="title-icons">
                        {image ? <img src={require(`../assets/img/icons/${image}`)} alt="" />  : null}
                        
                            
                        </div>
                        <div className="title-name">
                            <h1>{this.props.title}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
  }
}

export default Header;